import { Skeleton, Tbody, Td, Tr } from '@chakra-ui/react'

interface TableRowsSkeletonIProps {
  rowCount?: number
  columnCount: number
  rowHeight?: string
}

export const TableRowsSkeleton = ({
  rowCount = 10,
  columnCount,
  rowHeight = '52px',
}: TableRowsSkeletonIProps) => {
  return (
    <Tbody>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <Tr h={rowHeight} key={rowIndex}>
          <Td colSpan={columnCount} px='16px' py='8px'>
            <Skeleton h='16px' w='95%' />
          </Td>
        </Tr>
      ))}
    </Tbody>
  )
}
